import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Shared client — withCredentials for httpOnly cookies on admin/auth calls
export const http = axios.create({
  baseURL: API,
  timeout: 20000,
  withCredentials: true,
});

// ---------- Public ----------
export const fetchCategories = async () => (await http.get("/categories")).data;
export const fetchProducts = async (params = {}) =>
  (await http.get("/products", { params })).data;
export const fetchProduct = async (slug) =>
  (await http.get(`/products/${slug}`)).data;
export const fetchBlogPosts = async () => (await http.get("/blog")).data;
export const fetchBlogPost = async (slug) => (await http.get(`/blog/${slug}`)).data;
export const fetchTestimonials = async () => (await http.get("/testimonials")).data;
export const submitContact = async (payload) =>
  (await http.post("/contact", payload)).data;

// ---------- Auth ----------
export const authLogin = async (email, password) =>
  (await http.post("/auth/login", { email, password })).data;
export const authLogout = async () => (await http.post("/auth/logout")).data;
export const authMe = async () => (await http.get("/auth/me")).data;

// ---------- Admin ----------
export const adminListProducts = async () =>
  (await http.get("/admin/products")).data;
export const adminGetProduct = async (id) =>
  (await http.get(`/admin/products/${id}`)).data;
export const adminCreateProduct = async (payload) =>
  (await http.post("/admin/products", payload)).data;
export const adminUpdateProduct = async (id, payload) =>
  (await http.put(`/admin/products/${id}`, payload)).data;
export const adminDeleteProduct = async (id) =>
  (await http.delete(`/admin/products/${id}`)).data;
export const adminListLeads = async () => (await http.get("/admin/leads")).data;

export const adminUpload = async (file, folder = "products") => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("folder", folder);
  const { data } = await http.post("/admin/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

// ---------- Helpers ----------
/** Resolve a stored path (relative /api/files/..) to a usable image src. */
export const imageUrl = (src) => {
  if (!src) return "";
  if (typeof src === "object") {
    src = src.url;
  }
  if (!src) return "";
  if (/^https?:\/\//i.test(src)) return src;
  return `${BACKEND_URL}${src}`;
};

/** Format API error detail (FastAPI returns arrays for 422). */
export const formatApiError = (detail) => {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" · ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
